module.exports = __webpack_public_path__ + "static/media/video.df2d1172.svg";